import React from "react";
import { clients } from "../data/data";

const Clinets = () => {
  return (
    <div className="py-32">
      <div className="container mx-auto px-5">
        <div>
          <h3 className="text-6xl font-bold pb-5">Clients</h3>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-5 md:grid-cols-3 gap-12 mt-14">
          {clients.map((item, index) => (
            <div key={index}>
              <img src={item.img} className="h-20" alt="img" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Clinets;
